import { bulkUpdateProductsWithInventory as bulkUpdateProductsV3 } from '@wix/ambassador-stores-catalog-v3-product/http';
import { Version } from '@wix/ambassador-stores-catalog-v3-provision/types';
import { createHttpClient } from '@wix/fe-essentials/http-client';
import { chunk as getChunks } from 'lodash';
import { fetchProductPages } from '../new-infra-fetchers/fetch-products';
import { getStoreCatalogVersion } from '../new-infra-fetchers/get-stores-catalog-version';
import { buildBulkUpdatePayloadV1, buildBulkUpdatePayloadV3 } from './bulk-update-product-alt-text-payload-builder';
const BULK_LIMIT = 100;
export const updateProductsImageAltText = async (httpClient, errorHandler, storesInstance, altTextData) => {
  const {
    getResolvedError
  } = errorHandler;
  const entityIdsList = altTextData.map(item => item.entityId).filter(entityId => entityId !== undefined);
  try {
    const catalogVersion = await getStoreCatalogVersion(httpClient, errorHandler);
    const products = await fetchProductPages(httpClient, errorHandler, catalogVersion, entityIdsList);
    const productsMap = new Map(products.map(product => [product.id, product]));
    return catalogVersion === Version.V1_CATALOG ? await updateProductV1(errorHandler, storesInstance, altTextData, productsMap) : await updateProductV3(httpClient, errorHandler, altTextData, productsMap);
  } catch (err) {
    return {
      errorMessage: getResolvedError(err).message,
      success: false
    };
  }
};
const updateProductV1 = async (errorHandler, storesInstance, altTextData, productsMap) => {
  const httpClient = createHttpClient({
    headers: {
      Authorization: storesInstance
    }
  });
  const {
    withErrorHandler
  } = errorHandler;
  const allFailedElements = [];
  const chunks = getChunks(altTextData, BULK_LIMIT);
  const updatePromises = chunks.map(async chunk => {
    const commands = buildBulkUpdatePayloadV1(chunk, productsMap);
    if (!commands.length) {
      return {
        success: false
      };
    }
    const {
      data
    } = await withErrorHandler(async () => httpClient.post('/_api/wix-ecommerce-renderer-web/store-manager/executeCatalogCommands', {
      commands
    }), {
      errorCodesMap: {}
    });
    if (!data.success) {
      var _data$errors;
      const failedIndexes = data == null || (_data$errors = data.errors) == null ? void 0 : _data$errors.map(error => error.index);
      const failedElementsChunk = chunk.filter((_, index) => failedIndexes.includes(index));
      allFailedElements.push(...failedElementsChunk);
    }
    return {
      success: data.success
    };
  });
  const results = await Promise.all(updatePromises);
  const overallSuccess = results.every(result => result.success);
  return {
    failedElements: allFailedElements,
    success: overallSuccess
  };
};
const updateProductV3 = async (httpClient, errorHandler, altTextData, productsMap) => {
  const {
    withErrorHandler
  } = errorHandler;
  const allFailedElements = [];
  const chunks = getChunks(altTextData, BULK_LIMIT);
  const updatePromises = chunks.map(async chunk => {
    var _data$productResults, _data$productResults2;
    const payload = buildBulkUpdatePayloadV3(chunk, productsMap);
    if (!payload.products.length) {
      return {
        success: false
      };
    }
    const {
      data
    } = await withErrorHandler(async () => httpClient.request(bulkUpdateProductsV3(payload)), {
      errorCodesMap: {}
    });
    const success = (data == null || (_data$productResults = data.productResults) == null || (_data$productResults = _data$productResults.bulkActionMetadata) == null ? void 0 : _data$productResults.totalFailures) === 0;
    const results = (_data$productResults2 = data.productResults) == null ? void 0 : _data$productResults2.results;
    if (!success) {
      const failedIndexes = (results ?? []).map(_ref => {
        let {
          itemMetadata
        } = _ref;
        return itemMetadata == null ? void 0 : itemMetadata.originalIndex;
      }).filter(index => index !== undefined);
      const failedElementsChunk = chunk.filter((_, index) => failedIndexes.includes(index));
      allFailedElements.push(...failedElementsChunk);
    }
    return {
      success
    };
  });
  const results = await Promise.all(updatePromises);
  const overallSuccess = results.every(result => result.success);
  return {
    failedElements: allFailedElements,
    success: overallSuccess
  };
};
//# sourceMappingURL=update-products-image-alt-text.js.map